module.exports = import("https://widgets.oda.digital/vkplayer.js");;